import { render, staticRenderFns } from "./ReferralDetailsCard.vue?vue&type=template&id=0bec4abb"
import script from "./ReferralDetailsCard.vue?vue&type=script&lang=js"
export * from "./ReferralDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports